import { Injectable, NgZone } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Router } from "@angular/router";
import { map, shareReplay } from "rxjs/operators";
import firebase from "firebase/compat/app";
import {
  DocumentData,
  DocumentReference,
  addDoc,
  collection,
  deleteDoc,
  doc,
  where,
  getDoc,
  getDocs,
  getFirestore,
  orderBy,
  query,
  setDoc,
  updateDoc,
  Firestore,
} from "firebase/firestore";
import {
  GoogleAuthProvider,
  FacebookAuthProvider,
  EmailAuthProvider,
  signInWithPopup,
  OAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  getAuth,
  sendEmailVerification,
} from "firebase/auth";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import axios from "axios";
import { getApp, initializeApp } from "firebase/app";

export interface person {
  displayName: string;
  premiumUser: boolean; // subscribed to the app
  id: string;
  creatorType: "listener" | "creator" | "verified" | "premium" | "label"; // listener, artist, video, creator, label
  email: string | null;
  created?: string;
  handle?: string;
  stripeId?: string;
  likedVideos: any[];
  extraLinks?: [{ index: number; link: string; title: string }];
  socialLinks?: [
    {
      spotify?: string;
      youtube?: string;
      appleMusic?: string;
      facebook?: string;
      twitter?: string;
    }
  ];
  potentialSubscriptions?: {
    id: string;
    tier: string;
    price: number;
    description: string;
    creatorId: string;
    creatorName: string;
  };
  likedAlbums: any[];
  followers?: number;
  videoHistory: any[];
  watchLater: any[];
  likedSongs: any[];
  memberships?: [
    {
      id?: string;
      tier: string;
      level: string; // low, mid, high;
      price: number;
      description: string;
    }
  ];
  following?: [
    {
      creatorId: string;
      date: string;
      membership?: {
        id: string;
        tier: string;
        level: string; // low, mid, high;
        memberSince: string;
      };
    }
  ];
  city?: string;
  countryCode?: string;
  fanClub?: string;
  flag?: string;
  shortBio?: string;
  state?: string;
  country?: string;
  subEnd?: any;
  featureVideo?: any;
  artistsPick?: {
    art: string;
    name: string;
    type: string;
  };
  listenerCount?: number;
  viewerCount?: number;
}

@Injectable({
  providedIn: "root",
})
export class AuthService {
  db: Firestore;
  auth: any;
  creatorId: string;
  private userSubject: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);
  ui$: Observable<any | null> = this.userSubject.asObservable();
  public user: any;
  streams: any;
  // auth: any;
  // public user$: Observable<any> = this.auth.user.pipe(shareReplay(1));

  constructor(private router: Router, private ngZone: NgZone) {
    // this.initializeAuthListener();
  }
  initializeAuthListener() {
    onAuthStateChanged(getAuth(), async (user) => {
      if (user) {
        console.log(user);
        this.importUser(user.uid);
      } else {
        this.user = {
          displayName: "",
          premiumUser: false,
          id: "",
          creator: false,
          email: null,
          likedVideos: [],
          likedAlbums: [],
          videoHistory: [],
          watchLater: [],
          likedSongs: [],
        };
        this.userSubject.next(null);
        localStorage.setItem("user", "null");
        this.router.navigate(["/login"]);
      }
    });
  }

  async importUser(uid: any) {
    console.log(uid);
    this.creatorId = uid;
    const docRef = doc(getFirestore(), `users/${uid}`);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const userData = docSnap.data() as person;
      userData.id = docSnap.id;
      this.setUser(userData);
    } else {
      console.error("No such document!");
    }
  }

  setFire(db, auth) {
    this.db = db;
    this.auth = auth;
  }

  setUser(user: person) {
    if (user) {
      this.user = user;
      this.userSubject.next(this.user);
      localStorage.setItem("user", JSON.stringify(this.user));
      localStorage.setItem("isLoggedIn", "true");
    } else {
      localStorage.setItem("isLoggedIn", "false");

      localStorage.setItem("user", "null");
    }
    this.router.navigate(["/home"]);
  }

  setLogged() {
    localStorage.setItem("isLoggedIn", "true");
  }

  async addOrg(form) {}

  async signInWithGoogle() {
    // this.initializeAuthListener();
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(getAuth(getApp()), provider);
      console.log(result);
      this.importUser(result.user.uid);
      return result;
    } catch (error) {
      console.error("Google sign-in error:", error);
      throw error;
    }
  }

  signInWithEmail(email: string, password: string) {
    signInWithEmailAndPassword(this.auth, email, password)
      .then((res) => {
        console.log("AuthService::Successful Email login", res);
        this.setLogged();

        return this.ngZone.run(() => this.router.navigate(["/home"]));
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  }

  signUpWithEmail(email: string, password: string) {
    const auth = getAuth();
    createUserWithEmailAndPassword(auth, email, password)
      .then(async (res) => {
        this.setLogged();
        const auth = getAuth();

        // Assuming 'user' is the newly registered user
        const user = auth.currentUser;

        try {
          const verified = res.user.emailVerified ? true : false;

          return this.ngZone.run(() => this.router.navigate(["/home"]));
          // IdP data available using getAdditionalUserInfo(result)
          // ...
        } catch (error) {
          // Handle error
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        // ..
      });
  }

  getUser() {
    return this.user;
  }

  // isSmallBatchDevsLoggedIn$(): Observable<boolean> {
  //   return this.user$.pipe(map(user => user && user.email));
  // }

  logout() {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        this.userSubject.next("none");
        localStorage.clear();
        // Sign-out successful.
      })
      .catch((error) => {
        // An error happened.
      });
  }

  // Not Yet Implemented
  signInWithFacebook() {
    const auth = getAuth();
    const provider = new FacebookAuthProvider();
    signInWithPopup(auth, provider)
      .then((res) => {
        this.setLogged();
        return this.ngZone.run(() => this.router.navigate(["/home"]));
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  }

  // Not Yet Implemented
  signInWithApple() {
    const auth = getAuth();
    const provider = new OAuthProvider("apple.com");
    signInWithPopup(auth, provider)
      .then(async (res) => {
        this.setLogged();
        try {
          return this.ngZone.run(() => this.router.navigate(["/home"]));
          // IdP data available using getAdditionalUserInfo(result)
          // ...
        } catch (error) {
          // Handle error
        }
      })
      .catch((error) => {
        // Handle error
      });
  }

  async createStripeCustomer(user: any) {
    console.log("stripe  create " + user);
    let link = "https://tt.apps4artists.uk/backend/create-stripe-customer";
    axios
      .post(link, { user })
      .then((data) => {
        console.log("Stripe customer created:", data.data.stripeId);
      })
      .catch((error) => {
        console.error("Error creating subscription:", error);
        // Handle subscription creation error
      });
  }
}
